<template>
<div class="pos-r cmui-input form">
	<div v-if="type=='search'" class="input-search" :style="{display:type=='search'?'block':'none'}"></div>
    <!--<input v-if="!disabled" :type="type" :name="name" v-model="value" :placeholder="placeholder" :class="{'form-radius':radius,'input-reverse':reverse}">-->
    <!--<input v-else disabled :type="type" :name="name" v-model="value" :placeholder="placeholder" :class="{'form-radius':radius,'input-reverse':reverse}">-->
	<input v-if="!readOnly" :type="type" :name="name" v-model="value" :placeholder="placeholder" :class="{'form-radius':radius,'input-reverse':reverse}">
	<input v-else readonly :type="type" :name="name" v-model="value" :placeholder="placeholder" :class="{'form-radius':radius,'input-reverse':reverse}">
    <div class="input-reset" :style="{display:showReset}" v-if="reset==true" @click="resetInput()"></div>
</div>
</template>
<script>
export default {
	props:{
	    type:{type:String,default:'text'},
	    reset:{type:Boolean,default:true},
	    reverse:{type:Boolean,default:false},
	    placeholder:String,
		readOnly: {
	    	type: Boolean
			, default: false
		},
	    radius:{type:Boolean,default:true},
	    target: {type:Object},
	    value:{type:String,default:''},
	    name:{type:String, default: 'name'}
	},
	computed:{
	    showReset:function(){
	        return this.value.length?'block':'none';
	    }
	},
	methods:{
	    keyup:function(e){
	    	this.$dispatch('cmui-input-change', this, this.value)
	    },
	    resetInput:function(){
	        this.value='';
	        this.$el.getElementsByTagName('input')[0].focus()
	    }
	},
	watch: {
		value: function(){
			this.$dispatch('cmui-input-change', this, this.value)
		}
	}
	,
	ready:function(){
	    if(this.reset){
	        this.$el.getElementsByTagName('input')[0].style.paddingRight='40px';
	    }
	    if(this.type==='search'){
	        this.$el.getElementsByTagName('input')[0].style.paddingLeft='40px';
	    }
	}
};
</script>
